import { render, staticRenderFns } from "./ImportarForm.vue?vue&type=template&id=4867086c&scoped=true"
import script from "./ImportarForm.vue?vue&type=script&lang=ts"
export * from "./ImportarForm.vue?vue&type=script&lang=ts"
import style0 from "./ImportarForm.vue?vue&type=style&index=0&id=4867086c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867086c",
  null
  
)

export default component.exports